import React, { useContext, useState } from "react";
import {
  Grid,
  View,
  Card,
  Loader,
  Text,
} from '@aws-amplify/ui-react';
import AddressInput from "./AddressInput";
import CartUI from "./CartUI";
import '@aws-amplify/ui-react/styles.css';
import { CartStatus, BreedGroup, AgeBracket, Plans } from '../enums';
import {
  CartStateContext,
  //checkoutInProgress,
} from "../contexts/cart";
import Modal from 'react-modal';
// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { client } from '../apiClient';
import { createCart, createProposerUser, createCartItems, createProposerVet } from '../graphql/mutations';

// Gen 2 REST checkout endpoint (returns the CCAvenue payment src). Was the Gen 1
// endpoint nd8cp8vgud/prod/checkout; Gen 2 = pawtect-gen2-rest /prod/pawtectcheckout.
const REST_API_ENDPOINT = 'https://ok0zu6g2hk.execute-api.ap-southeast-1.amazonaws.com/prod/pawtectcheckout';


export default function Checkout(props) {
  const { items, address, vet, tncAgreed } = useContext(CartStateContext);
  const [showDialog, setShowDialog] = useState(false);
  const [showProgress, setShowProgress] = useState(false);
  const [src, setSrc] = useState({ src: '/failedcheckout' });
  const [isLoading, setIsLoading] = useState(false);
  //const [cartID, setCartID] = useState();

  async function handleCheckout() {
    setShowDialog(true);
    setShowProgress(true);
    setIsLoading(true);
    let cartID;
    try {
      cartID = await prepareCart();
      //console.log('Calling fetch:CartID:' + JSON.stringify(cartID));
    } catch (error) {
      console.error('Checkout: could not prepare cart', error);
      setShowProgress(false);
      setShowDialog(false);
      // Cart/address remain in context, so the user doesn't lose their entries.
      window.location.href = '/failedcheckout';
      return;
    }

    if (cartID) {
      await fetch(REST_API_ENDPOINT + '?cartId=' + cartID)
        .then((response) => response.json().then((data) => {
          setSrc(data);
          //console.log('handleCheckout-->' + JSON.stringify(data));
          window.location.href = data?.src ? data?.src : '/failedcheckout';
          setShowProgress(false);
          setTimeout(() => setShowDialog(false), 5000);

        }))
        .catch(error => {
          //console.log(error);
          setSrc('/failedcheckout');
          window.location.href = '/failedcheckout';
          setShowProgress(false);
          setShowDialog(false)
      })
    }
  }

  async function prepareCart() {
    const total_amount = (items.reduce((prev, curr) => { return prev = prev + curr?.quantity * curr?.premium_incl_gst }, 0));
    const sgst = (address?.state === 'Maharashtra' ? true : false)
    // Gen 2 models Cart -> ProposerUser/ProposerVet as hasOne via the CHILD's `cartId` FK.
    // Gen 1's cartProposerUserId/cartProposerVetId fields do NOT exist on CreateCartInput, so
    // sending them made createCart fail (-> prepareCart threw -> /failedcheckout, checkout never
    // called). Correct order: create the Cart first, then link each proposer by setting cartId.
    let cart = {
      "status": CartStatus.OPEN,
      "total_amount": total_amount,
      "tncagreed": tncAgreed,
    }
    try {
      cart = await client.graphql({ query: createCart, variables: { input: cart }, authMode: 'apiKey' });
      if (cart?.errors) {
        console.log(JSON.stringify(cart?.errors));
        throw cart?.errors[0];
      }
    } catch (error) {
      console.log(JSON.stringify(error));
      throw error;
    }
    const cartId = cart?.data?.createCart?.id;

    let proposerVet = null;
    if (vet?.id) {
      proposerVet = { vet_name: vet?.name, vet_id: vet?.id, cartId: cartId }
      try {
        proposerVet = await client.graphql({ query: createProposerVet, variables: { input: proposerVet }, authMode: 'apiKey' });
        if (proposerVet?.errors) {
          console.log(JSON.stringify(proposerVet?.errors));
          throw (proposerVet?.errors[0]);
        }
      } catch (error) {
        console.log(JSON.stringify(error));
        throw error;
      }
    }

    let proposerUser = {
      "fullName": address?.name,
      "mobile": address?.mobile,
      "email": address?.email,
      "pan": '',
      "addressLine1": address?.addressLine,
      "addressLine2": address?.area,
      "city": address?.city,
      "state": address?.state,
      "pincode": address?.pincode,
      "countryCode": "IN",
      "cartId": cartId,
    }
    try {
      proposerUser = await client.graphql({ query: createProposerUser, variables: { input: proposerUser }, authMode: 'apiKey' });
      if (proposerUser?.errors) {
        console.log(JSON.stringify(proposerUser?.errors));
        throw (proposerUser?.errors[0]);
      }
    } catch (error) {
      console.log(JSON.stringify(error));
      throw error;
    }

    // Await ALL cart-item creations before returning, so the checkout/CCAvenue call
    // never runs against a cart whose items haven't persisted yet. (Previously the
    // inner graphql call was not awaited and `await items.map(...)` just awaited an
    // array, so items could still be in flight when payment was initiated.)
    await Promise.all(items.map(async (item) => {
      const cartItem =
      {
        "age": AgeBracket[item?.age],
        "breed_group": BreedGroup[item?.breed_group],
        "breed": item?.breed,
        "premium_excl_gst": item?.premium_excl_gst?.toFixed(2),
        "cgst": +(item?.premium_excl_gst * 0.09)?.toFixed(2),
        "sgst": sgst ? +(item?.premium_excl_gst * 0.09)?.toFixed(2) : 0,
        "igst": sgst ? 0 : +(item?.premium_excl_gst * 0.09)?.toFixed(2),
        "microchip": item?.microchip,
        "microchip_excl_gst": 0?.toFixed(2),
        "plan": Plans[item?.plan],
        "sum_insured": item?.sum_insured,
        "quantity":item?.quantity,
        "cartID": cart?.data?.createCart?.id
      };
      const created = await client.graphql({ query: createCartItems, variables: { input: cartItem }, authMode: 'apiKey' });
      if (created?.errors) {
        console.log(JSON.stringify(created?.errors));
        throw created?.errors[0];
      }
      return created;
    }));
    return cart?.data?.createCart?.id;
  }

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  Modal.setAppElement('#root');

  return (
    <Card>
      <Grid
        alignItems="flex-start"
        alignContent="flex-start"
        templateColumns={{ base: '1fr', large: '1fr 2fr' }}
        templateRows={{ base: '2fr', large: '1fr' }}
        columnGap={'20px'}
      >
        <View columnSpan={1}>
          <AddressInput isLoading={isLoading} />
        </View>
        <View columnSpan={1}>
          <CartUI columnSpan={1}
            handleProceedCheckout={handleCheckout}
            isLoading={isLoading}
          >
          </CartUI>
        </View>
      </Grid>
      <Modal
        isOpen={showDialog}
        style={customStyles}
        contentLabel="Pawtect Payment"
      >{

          showDialog && showProgress ? (
            <Card>
              <Text fontWeight="bold">🔒 Redirecting to secure payment…</Text>
              <Text variation={'tertiary'}>
                Taking you to our secure payment partner (CCAvenue) to pay{' '}
                ₹{Number(items.reduce((p, c) => p + (c?.quantity || 1) * (c?.premium_incl_gst || 0), 0)).toFixed(2)}.
                Please don't refresh or press the back button.
              </Text>
              <br />
              <Loader
                size="large"
                variation="linear"
              />
            </Card>
          ) : (<div></div>       
          )
        }
      </Modal>
    </Card>
  );
}


